import React from 'react';
const TableTitle = props => /*#__PURE__*/React.createElement("h4", null, props.title, " ", props.additional || '');
export default TableTitle;